export type ThemeColors = {
  titleTextColor: string
  itemTextColor: string
  accordionArrowColor: string
}

export const DEFAULT_COLORS: ThemeColors = {
  titleTextColor: 'var(--colors-neutral-text-default)',
  itemTextColor: 'var(--colors-neutral-text-weak)',
  accordionArrowColor: 'var(--colors-cyan-icon-default)'
}

export const CONTRAST_COLORS: ThemeColors = {
  titleTextColor: 'var(--colors-neutral-text-contrast-default)',
  itemTextColor: 'var(--colors-neutral-text-contrast-default)',
  accordionArrowColor: 'var(--colors-cyan-background-pressed)'
}
